var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 52,
    viewBox: "0 0 143 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.013 51.563H5.28138C2.38095 51.563 0 48.6514 0 45.1044V6.45861C0 2.91167 2.38095 0 5.28138 0H137.013C139.913 0 142.294 2.91167 142.294 6.45861V45.1044C142.294 48.6514 139.913 51.563 137.013 51.563Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5639 16.7943C56.5639 17.5135 56.3511 18.1247 55.9256 18.5562C55.4291 19.0596 54.7908 19.3473 54.0106 19.3473C53.2659 19.3473 52.6275 19.0956 52.0956 18.5562C51.5637 18.0169 51.3154 17.3697 51.3154 16.6146C51.3154 15.8235 51.5637 15.1763 52.0956 14.6729C52.6275 14.1335 53.2659 13.8818 54.0106 13.8818C54.3652 13.8818 54.7198 13.9537 55.0745 14.0976C55.4291 14.2414 55.6773 14.4571 55.8901 14.6729L55.4291 15.1403C55.0745 14.7088 54.6135 14.5291 54.0106 14.5291C53.4786 14.5291 52.9822 14.7088 52.5921 15.1044C52.202 15.4999 51.9892 16.0033 51.9892 16.6146C51.9892 17.2258 52.202 17.7292 52.5921 18.1247C52.9822 18.5203 53.4786 18.7001 54.0106 18.7001C54.578 18.7001 55.0745 18.5203 55.4646 18.1247C55.7128 17.873 55.8546 17.5135 55.8901 17.046H54.0106V16.3988H56.5284C56.5639 16.5426 56.5639 16.6865 56.5639 16.7943Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.22927,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5719 14.6013H58.1959V16.2553H60.3237V16.9026H58.1959V18.5566H60.5719V19.2038H57.5576V13.9541H60.5719V14.6013Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.22927,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3729 19.2038H62.6991V14.6013H61.2451V13.9541H64.7914V14.6013H63.3374V19.2038H63.3729Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.22927,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3809 19.2038V13.9541H68.0547V19.2038H67.3809Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.22927,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9979 19.2038H70.3241V14.6013H68.8701V13.9541H72.4164V14.6013H70.9624V19.2038H70.9979Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.22927,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1892 18.5562C78.6928 19.0956 78.0544 19.3473 77.2743 19.3473C76.5295 19.3473 75.8912 19.0956 75.3593 18.5562C74.8628 18.0169 74.5791 17.3697 74.5791 16.6146C74.5791 15.8595 74.8273 15.2122 75.3593 14.6729C75.8558 14.1335 76.4941 13.8818 77.2743 13.8818C78.019 13.8818 78.6573 14.1335 79.1538 14.6729C79.6503 15.2122 79.934 15.8595 79.934 16.6146C79.9694 17.3697 79.6857 18.0169 79.1892 18.5562ZM75.8912 18.0888C76.2813 18.4843 76.7423 18.6641 77.3097 18.6641C77.8771 18.6641 78.3381 18.4843 78.7282 18.0888C79.1183 17.6933 79.2956 17.1899 79.2956 16.5786C79.2956 15.9673 79.1183 15.4639 78.7282 15.0684C78.3381 14.6729 77.8771 14.4931 77.3097 14.4931C76.7423 14.4931 76.2813 14.6729 75.8912 15.0684C75.5011 15.4639 75.3238 15.9673 75.3238 16.5786C75.3238 17.1899 75.5011 17.6933 75.8912 18.0888Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.22927,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8916 19.2038V13.9541H81.7072L84.2251 18.0532H84.2605L84.2251 17.0464V13.9541H84.8989V19.2038H84.1896L81.5654 14.9249H81.5299L81.5654 15.9317V19.2038H80.8916Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.22927,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4727 26.898C72.4513 26.898 70.7846 28.4801 70.7846 30.6376C70.7846 32.795 72.4513 34.3771 74.4727 34.3771C76.4941 34.3771 78.1608 32.795 78.1608 30.6376C78.1608 28.4442 76.4941 26.898 74.4727 26.898ZM74.4727 32.8669C73.3734 32.8669 72.4159 31.932 72.4159 30.6016C72.4159 29.2712 73.3734 28.3363 74.4727 28.3363C75.572 28.3363 76.5295 29.2352 76.5295 30.6016C76.5295 31.932 75.572 32.8669 74.4727 32.8669ZM66.4227 26.898C64.4013 26.898 62.7346 28.4801 62.7346 30.6376C62.7346 32.795 64.4013 34.3771 66.4227 34.3771C68.4441 34.3771 70.1108 32.795 70.1108 30.6376C70.1108 28.4442 68.4441 26.898 66.4227 26.898ZM66.4227 32.8669C65.3233 32.8669 64.3659 31.932 64.3659 30.6016C64.3659 29.2712 65.3233 28.3363 66.4227 28.3363C67.522 28.3363 68.4795 29.2352 68.4795 30.6016C68.4795 31.932 67.522 32.8669 66.4227 32.8669ZM56.8478 28.0127V29.5948H60.5714C60.465 30.4937 60.1813 31.141 59.7203 31.5724C59.1883 32.1118 58.3372 32.7231 56.8478 32.7231C54.5427 32.7231 52.7696 30.8533 52.7696 28.5161C52.7696 26.1789 54.5782 24.3092 56.8478 24.3092C58.089 24.3092 58.9755 24.8125 59.6493 25.4238L60.7487 24.3092C59.8266 23.4102 58.5855 22.7271 56.8478 22.7271C53.6916 22.7271 51.0674 25.3159 51.0674 28.5161C51.0674 31.7163 53.7271 34.3052 56.8478 34.3052C58.55 34.3052 59.8266 33.7298 60.8196 32.6871C61.848 31.6443 62.1672 30.1701 62.1672 28.9835C62.1672 28.624 62.1317 28.2644 62.0963 28.0127H56.8478ZM95.963 29.2352C95.6439 28.4082 94.7218 26.8621 92.8069 26.8621C90.9273 26.8621 89.3315 28.3723 89.3315 30.6016C89.3315 32.6871 90.8919 34.3411 92.9842 34.3411C94.6509 34.3411 95.6439 33.2984 96.034 32.6871L94.7928 31.8241C94.3672 32.4354 93.7998 32.8669 92.9842 32.8669C92.1685 32.8669 91.5657 32.4714 91.211 31.7522L96.1049 29.7027L95.963 29.2352ZM90.9628 30.4937C90.9273 29.0555 92.0621 28.3363 92.8778 28.3363C93.5161 28.3363 94.0481 28.6599 94.2254 29.1274L90.9628 30.4937ZM86.991 34.0894H88.5868V23.1585H86.991V34.0894ZM84.3313 27.7251H84.2604C83.9058 27.2936 83.1965 26.898 82.3099 26.898C80.4659 26.898 78.7991 28.5161 78.7991 30.6376C78.7991 32.7231 80.4659 34.3411 82.3099 34.3411C83.1965 34.3411 83.8703 33.9456 84.2604 33.4782H84.3313V34.0175C84.3313 35.4558 83.5866 36.2109 82.3809 36.2109C81.3879 36.2109 80.785 35.4917 80.5368 34.8805L79.1183 35.4558C79.5084 36.4266 80.6077 37.6491 82.3809 37.6491C84.2604 37.6491 85.8562 36.5345 85.8562 33.7658V27.1138H84.3313V27.7251ZM82.4872 32.8669C81.3879 32.8669 80.4304 31.932 80.4304 30.6376C80.4304 29.3431 81.3524 28.3723 82.4872 28.3723C83.5866 28.3723 84.4377 29.3431 84.4377 30.6376C84.4377 31.932 83.5866 32.8669 82.4872 32.8669ZM103.517 23.1585H99.6866V34.0894H101.282V29.9544H103.517C105.29 29.9544 107.063 28.6599 107.063 26.5385C107.063 24.417 105.325 23.1585 103.517 23.1585ZM103.587 28.4442H101.282V24.6687H103.587C104.793 24.6687 105.467 25.6755 105.467 26.5385C105.467 27.4014 104.793 28.4442 103.587 28.4442ZM113.517 26.8621C112.347 26.8621 111.141 27.3655 110.645 28.5521L112.063 29.1633C112.382 28.5521 112.95 28.3723 113.552 28.3723C114.368 28.3723 115.219 28.8757 115.255 29.7746V29.8825C114.971 29.7027 114.333 29.451 113.588 29.451C112.063 29.451 110.467 30.3139 110.467 31.932C110.467 33.4062 111.744 34.3411 113.162 34.3411C114.262 34.3411 114.829 33.8377 115.219 33.2624H115.29V34.0894H116.851V29.8825C116.815 27.9408 115.361 26.8621 113.517 26.8621ZM113.34 32.8669C112.808 32.8669 112.063 32.6152 112.063 31.932C112.063 31.105 112.985 30.7814 113.765 30.7814C114.475 30.7814 114.794 30.9252 115.255 31.141C115.113 32.1477 114.262 32.8669 113.34 32.8669ZM122.489 27.1138L120.61 31.8601H120.539L118.624 27.1138H116.886L119.758 33.7298L118.127 37.4334H119.794L124.227 27.1138H122.489ZM107.949 34.0894H109.545V23.1585H107.949V34.0894Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8219 11.3984C18.5182 11.7365 18.3447 12.3161 18.3447 13.0406V39.0268C18.3447 39.7513 18.5182 40.3309 18.8219 40.669L18.9087 40.7656L31.9661 26.1786V25.9854V25.7922L18.9087 11.3018L18.8219 11.3984Z",
    fill: "url(#paint0_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3472 31.0569L31.9658 26.1784V25.9852V25.792L36.3472 20.9136L36.434 20.9619L41.5962 24.2464C43.0711 25.1641 43.0711 26.7097 41.5962 27.6275L36.434 31.0086L36.3472 31.0569Z",
    fill: "url(#paint1_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4346 31.0087L31.9665 26.0337L18.8223 40.669C19.2994 41.2486 20.1237 41.2969 21.0347 40.7173L36.4346 31.0087Z",
    fill: "url(#paint2_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4346 21.0583L21.0347 11.3014C20.1237 10.7218 19.3428 10.8184 18.8223 11.3497L31.9665 25.9851L36.4346 21.0583Z",
    fill: "url(#paint3_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.3478 30.8633L21.0347 40.5719C20.1671 41.1032 19.4296 41.0549 18.909 40.5719L18.8223 40.6685L18.909 40.7651C19.3862 41.2481 20.1671 41.2964 21.0347 40.7651L36.4346 31.0082L36.3478 30.8633Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M18.8219 40.5236C18.5182 40.1855 18.3447 39.6059 18.3447 38.8813V39.0746C18.3447 39.7991 18.5182 40.3787 18.8219 40.7168L18.9087 40.6202L18.8219 40.5236Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M41.5967 27.5793L36.3477 30.9121L36.4344 31.0087L41.5967 27.7242C42.3341 27.2412 42.7245 26.6616 42.7245 26.0337C42.6378 26.565 42.2907 27.1446 41.5967 27.5793Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M21.0343 11.4954L41.6399 24.5368C42.2906 24.9715 42.681 25.5028 42.7678 26.0824C42.7678 25.4545 42.3773 24.8749 41.6399 24.3919L21.0343 11.3505C19.5594 10.4328 18.3447 11.2056 18.3447 13.0893V13.2825C18.3447 11.3022 19.5594 10.5294 21.0343 11.4954Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 30.8258,
    y1: 12.7528,
    x2: 11.2047,
    y2: 30.3748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 43.5353,
    y1: 26.0306,
    x2: 17.9811,
    y2: 26.0306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 34.0232,
    y1: 28.7291,
    x2: 7.41546,
    y2: 52.6259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 15.5103,
    y1: 2.71784,
    x2: 27.3918,
    y2: 13.3888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.fbb8f6ace3330a2e2b16c210c4688a0b.svg";
export { ForwardRef as ReactComponent };